module.exports = __webpack_public_path__ + "img/logo.3b4c9704.svg";